import React from "react";
import { useControls } from "react-zoom-pan-pinch";
import { FiPlus, FiMinus } from "react-icons/fi";
import "./ZoomControls.css";

const ZoomControls = () => {
  const { zoomIn, zoomOut } = useControls();
  const isMobileDevice = () => {
    return /Mobi|Android|iPhone/i.test(navigator.userAgent);
  };
  return (
    <>
      {isMobileDevice() ? null : (
        <>
          <div className="Zoomtools">
            <button onClick={() => zoomIn()}>
              <FiPlus size={20} />
            </button>
            <button onClick={() => zoomOut()}>
              <FiMinus size={20} />
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default ZoomControls;
